import React from 'react';

import styled from 'styled-components';
import { MemberShipOptions } from 'constants/index';
import SubMenu from 'components/common/SubMenu';
import Head from 'next/head';
import Link from 'next/link';
import MembershipInfo from './components/MembershipInfo';

const MemberShipIntroService: React.FC = () => {
  return (
    <>
      <Head>
        <title>로컬스티치 - 멤버십</title>
        <meta name="application-name" content="로컬스티치-멤버십" />
        <meta name="msapplication-tooltip" content="로컬스티치-멤버십" />
        <meta
          id="meta_og_title"
          property="og:title"
          content="로컬스티치-멤버십"
        />
      </Head>
      <SubMenu options={MemberShipOptions} selected="멤버십소개" />
      <div className="cnts-wrap">
        <div className="membership-w">
          <MembershipInfo />
          <div className="cnts-box2">
            <MembershipTypeWrapper>
              <div className="in-cnts">
                <div className="img-w">
                  <MembershipType>
                    <MembershipTypeHeader>
                      <img src="images/membership_nimg01.jpg" alt="" />
                    </MembershipTypeHeader>
                    <MembershipTypeBody>
                      <MembershipImgWrapper>
                        <div>
                          <img src="images/membership_nimg02.jpg" alt="" />
                        </div>
                        <Link href="/membership/join">
                          <MemberShipTypeBtn>신청하기</MemberShipTypeBtn>
                        </Link>
                      </MembershipImgWrapper>
                      <MembershipImgWrapper>
                        <div>
                          <img src="images/membership_nimg03.jpg" alt="" />
                        </div>
                        <Link href="/tour">
                          <MemberShipTypeBtn>문의하기</MemberShipTypeBtn>
                        </Link>
                      </MembershipImgWrapper>
                    </MembershipTypeBody>
                  </MembershipType>
                </div>

                <div style={{ textAlign: 'center' }}>&nbsp;</div>
              </div>
            </MembershipTypeWrapper>
            <div className="in-cnts">
              <div className="img-w">
                <img src="images/membership_nimg0301.jpg" alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
const MembershipTypeWrapper = styled.div`
  @media (min-width: 286px) {
    margin-bottom: 20px;
  }
  @media (min-width: 786px) {
    margin-bottom: 40px;
  }
  @media (min-width: 900px) {
    margin-bottom: 60px;
  }
`;
const MembershipType = styled.div``;
const MembershipTypeHeader = styled.div``;
const MembershipTypeBody = styled.div`
  display: flex;
`;
const MembershipImgWrapper = styled.div`
  &:nth-child(1) {
    margin-right: 10px;
  }
`;
const MemberShipTypeBtn = styled.button`
  cursor: pointer;
  border: 2px solid #323232;
  border-radius: 20px;
  font-weight: bold;
  width: 100%;
  background-color: black;
  color: white;
  font-size: 12px;
  @media (min-width: 486px) {
    font-size: 12px;
    height: 35px;
  }
  @media (min-width: 786px) {
    font-size: 15px;
    height: 45px;
  }
  @media (min-width: 900px) {
    font-size: 14px;
    height: 50px;
  }
`;
export default MemberShipIntroService;
